import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import React from 'react';
import { Link } from 'react-router-dom';

import InfoIcon from '@/assets/icons/info-icon.svg?react';
import RightArrowIcon from '@/assets/icons/right-arrow.svg?react';
import { Alert } from '@/components/molecules/Alert';
import { useTranslator } from '@/hooks/useTranslator';

export const VerifyBusinessBanner: React.FC = (): React.ReactElement => {
  const tr = useTranslator();

  return (
    <Box component={Link} to="/verify-business">
      {/* TODO: make it depend on the state and have the right value */}
      <Alert
        variant="info"
        leftIcon={<InfoIcon fill="currentColor" />}
        rightIcon={<RightArrowIcon fill="currentColor" />}>
        <Typography fontSize={16} fontWeight={400} lineHeight="24px">
          {tr('VERIFY_BUSINESS_BANNER')}
        </Typography>
      </Alert>
    </Box>
  );
};
